<template>
  <section class="ct-products-feed">
    <div class="ct-products-feed__container container">
      <div class="content-type__content">
        <div
          v-if="slice?.Settings?.Title"
          class="content-type__heading heading heading--2"
        >
          {{ slice.Settings.Title }}
        </div>

        <p
          v-if="slice?.Settings?.Description"
          class="content-type__description"
        >
          {{ slice.Settings.Description }}
        </p>

        <ProductSlider
          v-if="slice?.FeedDisplay?.Display === 'Slider'"
          :products="slice.Products.map(data => data.product)"
          :lazy="index > 0"
        />

        <ul
          v-else-if="slice?.FeedDisplay?.Display === 'Grid'"
          class="ct-products-feed__grid"
        >
          <li
            v-for="(data, i) in slice.Products"
            :key="data"
            class="ct-products-feed__grid-item"
          >
            <ProductTile
              :product="data.product"
              :lazy="index > 0 || i > 2"
            />
          </li>
        </ul>

      <!--  -->
      <!--  -->
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
const props = defineProps({
  slice: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  slices: {
    type: Array,
    required: true,
  },
})

const { slice } = toRefs(props)
</script>

<style>
@import url("~layers/app/components/Slices/ProductsFeed.css");
</style>
